import { setBudget } from "../store/mainStore";

export interface Budget {
  ID: number;
  YEAR: number;
  MONTH: number;
  TYPE: number;
  CATEGORY: string;
  DETAIL: string;
  AMOUNT: number;
}

export interface Type {
  ID: number;
  NAME: string;
}

export interface Category {
  ID: number;
  NAME: string;
  TYPE: number;
}

export const getBudget = async (
  year: number,
  month: number,
  type: number = 0
) => {
  let result: Budget[] = [];
  await fetch("/budget.php?cmd=getBudget", {
    method: "post",
    body: JSON.stringify({ YEAR: year, MONTH: month, TYPE: type }),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(function (res) {
      return res.json();
    })
    .then((res) => {
      res.forEach((r: any) => {
        let rItem: Budget = {
          ID: +r.ID,
          YEAR: +r.YEAR,
          MONTH: +r.MONTH,
          TYPE: +r.TYPE,
          CATEGORY: r.CATEGORY,
          DETAIL: r.DETAIL,
          AMOUNT: +r.AMOUNT,
        };
        result.push(rItem);
      });
    });
  localStorage.setItem("budgets", JSON.stringify(result));
  return result;
};

export const addBudget = async (list: Budget[]) => {
  let result = null;
  await fetch("/budget.php?cmd=insertBulk", {
    method: "post",
    body: JSON.stringify(list),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(function (res) {
      return res.json();
    })
    .then((res) => {
      result = res;
    });
  return result;
};

export const updateBudget = async (item: Budget) => {
  let result = null;
  await fetch("/budget.php?cmd=updateBudget", {
    method: "post",
    body: JSON.stringify(item),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(function (res) {
      return res.json();
    })
    .then((res) => {
      result = res;
    });
  return result;
};

export const removeBudget = async (item: Budget) => {
  let result = null;
  await fetch("/budget.php?cmd=deleteBudget", {
    method: "post",
    body: JSON.stringify(item),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(function (res) {
      return res.json();
    })
    .then((res) => {
      result = res;
    });
  return result;
};

export const getTypes = async (params: any) => {
  let result: Type[] = [];
  await fetch("/budget.php?cmd=getType", {
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(function (res) {
      return res.json();
    })
    .then((res) => {
      res.forEach((r: any) => {
        let rItem: Type = { ID: +r.ID, NAME: r.NAME };
        result.push(rItem);
      });
    });
  localStorage.setItem("types", JSON.stringify(result));
  return result;
};

export const getCategories = async (params: any) => {
  let result: Category[] = [];
  await fetch("/budget.php?cmd=getCategories", {
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(function (res) {
      return res.json();
    })
    .then((res) => {
      res.forEach((r: any) => {
        let rItem: Category = { ID: +r.ID, NAME: r.NAME, TYPE: +r.TYPE };
        result.push(rItem);
      });
    });
  return result;
};

export const removeDoRoutine = async (params: any) => {
  let result = "";
  await fetch("/db.php?cmd=D", {
    method: "post",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(function (res) {
      return res.json();
    })
    .then((res) => {
      result = res;
    });
  return result;
};

export const getRoutineSchedule = async () => {
  let result = "";
  await fetch("/db.php?cmd=getRoutineSchedule")
    .then(function (res) {
      return res.json();
    })
    .then((res) => {
      result = res;
    });
  return result;
};
